<template>
    <div class="page-container">
        <md-toolbar class="md-primary">
            <md-button class="md-icon-button" @click="showNavigation = true">
                <md-icon>menu</md-icon>
            </md-button>
            <span class="md-title">Dashboard RSui</span>
            <div class="right-align">
                <md-button class="md-dense log-out-btn" style="font-size: 15px;" @click.native="logOut"><b style="font-size: 15px;">Sair</b></md-button>
            </div>
        </md-toolbar>
        <md-drawer :md-active.sync="showNavigation">
            <md-toolbar class="md-middle" style="background: #448aff;">
                <div class="md-toolbar-container logo-sistema" style="margin-top: -50px;">
                    <img src="/static/logo_rsui_bco.png" alt="Logo" style="width: 80%;"></img>
                </div>
            </md-toolbar>
            <div class="main-sidebar-links">
                <md-list layout="row" class="md-dense" v-for="menuItem in menu_itens" :key="menuItem" :value="menuItem">
                    <md-list-item v-if="menuItem.subItens == null"> 
                        <md-icon style="margin-left: 3%; margin-right: 0px;">library_books</md-icon>
                        <md-button style="white-space: normal !important; word-break: break-all; font-size: 13px; text-transform: capitalize; margin-left: -2%;" @click.native="navigateComponents(menuItem)">{{menuItem.description}}</md-button>
                    </md-list-item>
                    <md-list-item v-if="menuItem.subItens != null" md-expand>
                        <md-icon style="width: 50px !important; margin-left: -3%;">folder</md-icon>
                        <span class="md-list-item-text" style="white-space: normal !important; word-break: break-all; font-size: 13px; margin-left: -16%;">{{menuItem.name}}</span>
                        <md-list-expand slot="md-expand">
                            <md-list style="margin-bottom: -20px;" v-for="item in menuItem.subItens" :key="item.name">
                                <md-list-item>
                                    <md-icon style="margin-left: 6%; margin-right: 0px;">library_books</md-icon>
                                    <md-button style="white-space: normal !important; word-break: break-all; margin-left: 0px; text-align: left; font-size: 13px; text-transform: capitalize;" @click.native="navigateComponents(item)">{{item.description}}</md-button>
                                </md-list-item>
                            </md-list>
                        </md-list-expand>
                    </md-list-item>
                </md-list>
            </div>
        </md-drawer>
        <md-content style="background-color: #e1e1e152; margin-right: 4px;">
            <slot name="slotForm"></slot>
        </md-content>
        <md-snackbar :md-position="position" ref="msgSuccessSistema" :md-duration="duration">
            <span v-model="msgSuccessSistema"></span>
            <md-button class="md-primary button-blue" md-theme="themeBlue" @click="$refs.msgSuccessSistema.close()">OK!</md-button>
        </md-snackbar>
        <md-snackbar :md-position="position" ref="msgErrorSistema" :md-duration="duration" :md-active.sync="showSnackbar" md-persistent>
            <span v-model="msgErrorSistema"></span>
            <md-button class="md-accent button-red" md-theme="themeBlue" @click="$refs.msgErrorSistema.close()">OK!</md-button>
        </md-snackbar>
    </div>
</template>

<script>
    export default {
        name: 'menuLayout',

        methods: {
            logOut: function () {
                localStorage.setItem('access_token', '');
                localStorage.setItem('expiration', '');
                this.$root.expiration = '';
                this.$root.accessToken = '';
                this.$parent.$router.push('/');
            },
            navigateComponents: function(component) {
                this.$parent.$router.push({ path: component.name });
            },
        },
        mounted() {
        },

        data: () => ({
            nome_tela: '',
            toolbar: true,
            showSnackbar: false,
            position: 'center',
            duration: 4000,
            msgSuccessSistema: '',
            msgErrorSistema: '',
            menu_itens: [
                {
                    description: 'DashBoard',
                    name: 'DashBoard',
                    url: 'DashBoard',
                    subItens: null
                },
                {
                    description: 'Item Condenações',
                    name: 'Condenações',
                    subItens: [
                        {
                            description: 'Totais',
                            name: 'CondenacoesTotais',
                            url: 'CondenacoesTotais'
                        },
                        {
                            description: 'Evolução',
                            name: 'CondenacoesEvolucao',
                            url: 'CondenacoesEvolucao'
                        },
                        {
                            description: 'Geolocalizadas',
                            name: 'CondenacoesGeolocalizadas',
                            url: 'CondenacoesGeolocalizadas'
                        }
                    ]
                }
            ],
            showNavigation: false
        })
    }
</script>

<style>
.logo-sistema {
    padding-top: 24%;
    padding-left: 12%;
}

.log-out-btn {
    text-transform: capitalize; 
    min-width: 40px; 
    background: #1565C0; 
    font-size: 15px;
}

.md-button .md-ripple {
    justify-content: flex-start;
}

.page-container {
    min-width: calc(100vw - 0px);
}

.md-drawer {
    width: 250px;
}

.md-content {
    padding: 16px;
}

.right-align {
    margin: auto;
    margin-right: 0px;
    display: flex;
    align-items: center;
}
.md-list-item-content{
    min-height: 48px;
    padding: 4px 16px;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    transition: padding .4s cubic-bezier(.25,.8,.25,1);
    will-change: padding;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuLayout.vue